import { cn } from "../../helpers"

const root = (className?: string) =>
  cn(
    "data-[state=checked]:bg-blurple-500 data-[state=unchecked]:bg-neutral-100 inline-flex h-8 w-[3.25rem] shrink-0 cursor-pointer items-center rounded-full p-1 transition-colors",
    "focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none",
    "disabled:cursor-not-allowed disabled:data-[state=unchecked]:bg-neutral-50 disabled:data-[state=checked]:bg-blurple-300",
    className,
  )
const thumb = (className?: string, isDisabled?: boolean) =>
  cn(
    "pointer-events-none block h-6 w-6 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0",
    isDisabled
      ? "data-[state=unchecked]:bg-neutral-400 data-[state=checked]:bg-[hsla(0,0%,100%,0.64)]"
      : "bg-white",
    className,
  )

export { root, thumb }
